import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';
import TimeUtils from '../utils/TimeUtils';

export default class CutOffUtils {
  static weccTradingDayPrefix = "WECC";
  static hourEndingMinusPrefix = "TMINUS";
  static delimiter = "-";

  static defaultWeccCutOffTime = '06:00:00';
  static defaultTMinusCutOffPeriod = '00:00:00';

  static parseType(value) {
    if (!StringUtils.isNonEmptyString(value))
      return null;

    var index = value.indexOf(CutOffUtils.delimiter);
    if (index === -1)
      return null;

    var cutOffType = value.substring(0, index);
    return cutOffType === this.weccTradingDayPrefix || cutOffType === this.hourEndingMinusPrefix
      ? cutOffType
      : null;
  }

  static parseTime(value) {
    if (!StringUtils.isNonEmptyString(value))
      return null;

    var index = value.indexOf(CutOffUtils.delimiter);
    if (index === -1)
      return null;

    var cutOffTime = value.substring(index + 1);
    var cutOffTimeValues = TimeUtils.parseTime(cutOffTime);

    return CoreUtils.isDefinedAndNotNull(cutOffTimeValues)
      ? cutOffTime
      : null;
  }

  static combineTypes(cutOffType, cutOffTime) {
    return cutOffType + CutOffUtils.delimiter + cutOffTime;
  }
}